import { Injectable } from '@angular/core';

import { AnalyticsMode } from '@core/analytics-types';

import { AnalyticsBase } from '../analytics-base';

export enum NotificationTarget {
  Candidate = 'candidate',
}

@Injectable()
export class NotificationsAnalytics extends AnalyticsBase {
  public readonly namespace = 'Notifications';
  public readonly requireViewContext = true;

  public trackFollowAction(target: string, mode: AnalyticsMode, candidatesCount: number = 1) {
    this.track('Follow', { target, mode, candidatesCount });
  }

  public trackUnfollowAction(target: string, mode: AnalyticsMode, candidatesCount: number = 1) {
    this.track('Unfollow', { target, mode, candidatesCount });
  }

  public trackOpenSettings() {
    this.track('OpenSettings');
  }
}
